export default __webpack_public_path__ + "static/media/5.909e1a5d.webp";